import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, Header } from 'semantic-ui-react';
import failIcon from '../../../assets/images/fail.svg';
import checkIcon from '../../../assets/images/greenCheck.svg';
import classes from './PaymentInformation.css';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'myHUDDLE: Subscription Status';

class PaymentInformation extends Component {
  static propTypes = {
    currentSubscriptionStatus: PropTypes.string,
    subscription: PropTypes.shape({
      current_subscription_ends_at: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    currentSubscriptionStatus: null,
  };

  componentDidMount() {
    document.title = `${pageTitle} - TheHuddle`;
    gciPageView(pageTitle);
  }

  renderStatus = () => {
    const { currentSubscriptionStatus } = this.props;
    if (currentSubscriptionStatus === 'A') {
      return (
        <div className={`${classes.subscriptionStatus} active`}>
          Subscription Status
          <img src={checkIcon} alt="" />
          <span>Active</span>
        </div>
      );
    }
    return (
      <div className={`${classes.subscriptionStatus} inactive`}>
        Subscription Status
        <img src={failIcon} alt="" />
        <span>Inactive</span>
      </div>
    );
  }

  render() {
    const { subscription } = this.props;
    const subscriptionEndDate = moment(subscription.current_subscription_ends_at)
          .format('MMMM D, YYYY');
    return (
      <Grid columns={16} className={classes.PaymentInformation}>
        <Grid.Row>
          <Header className={classes.header} as="h1">
            {pageTitle}
          </Header>
        </Grid.Row>
        <Grid.Row>
          <div className={classes.label}>
            {this.renderStatus()}
          </div>
          <p>Your subscription period ends on <b>{subscriptionEndDate}</b>.</p>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(state => ({
  subscription: state.paymentInformation,
  currentSubscriptionStatus: state.auth.user && state.auth.user.status,
}))(PaymentInformation);



// WEBPACK FOOTER //
// ./src/app/views/PaymentInformation/index.js